import { useLayoutEffect } from "react";
import { getAsset } from "@/utils/assets";

export type ThemeProviderProps = {
  children: React.ReactNode;
};

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  useLayoutEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
        @font-face {
            font-family: "PT Sans";
            src: url(${getAsset("/fonts/PTSans/PTSans-Regular.woff2")}) format("woff2");
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: "PT Sans";
            src: url(${getAsset("/fonts/PTSans/PTSans-Bold.woff2")}) format("woff2");
            font-weight: 700;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: "PT Sans";
            src: url(${getAsset("/fonts/PTSans/PTSans-Italic.woff2")}) format("woff2");
            font-weight: 400;
            font-style: italic;
            font-display: swap;
        }

        @font-face {
            font-family: "PT Sans";
            src: url(${getAsset("/fonts/PTSans/PTSans-BoldItalic.woff2")}) format("woff2");
            font-weight: 700;
            font-style: italic;
            font-display: swap;
        }

        @font-face {
            font-family: "Space Mono";
            src: url(${getAsset("/fonts/SpaceMono/SpaceMono-Regular.woff2")}) format("woff2");
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }
    `;
    document.head.appendChild(style);
    document.documentElement.classList.add("js-font-loaded");
    return () => {
      style.remove();
      document.documentElement.classList.remove("js-font-loaded");
    };
  }, []);

  return <>{children}</>;
};
